import { cva } from "class-variance-authority";

export const checkboxVariants = cva(
  "border-border h-4 w-4 rounded-[4px] border transition-all focus:ring-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 mt-px flex-none checked:bg-brand-9 focus:ring-accent-9/30 focus:border-accent-9 checked:border-accent-9 hover:border-accent-9 unchecked:bg-card",
  {
    variants: {
      size: {
        sm: "h-3 w-3",
        md: "h-4 w-4",
        lg: "h-5 w-5 rounded-md",
      },
    },
  }
);

export const checkboxLabelVariants = cva("select-none text-foreground grid gap-1 font-normal", {
  variants: {
    size: {
      sm: "text-xs",
      md: "text-sm",
      lg: "text-base",
    },
    disabled: {
      true: "opacity-50 cursor-not-allowed",
    },
  },
});
